import { html, css, SoloLitElement } from '@core/solo-lit-element';
import '@bog-design-system/bd-icon';
import '@bog-design-system/bd-tooltip';

class SoloScrollUp extends SoloLitElement {
    static get is() {
        return 'solo-scroll-up';
    }

    static get styles() {
        return css`
            :host {
                --btn-size: 40px;
                --btn-margin-size: var(--space-4);
            }
            
            :host([hidden]) {
                display: none;
            }
            
            .container {
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                width: var(--btn-size);
                height: var(--btn-size);
                background-color: var(--color-slate-grey);
                border-radius: 50%;
                box-shadow: 0px 4px 8px 0 rgba(0, 0, 0, 0.1);
                transition: all 0.1s ease-out;
                margin: var(--btn-margin-size);
            }

            .container:hover {
                background-color: var(--color-dark);
                transition: all 0.1s ease-in;
            }

            .icon {
                color: var(--color-white);
                width: 15px;
            }

            @media (max-width: 1500px) {
                .container {
                    bottom: var(--space-64);
                    right: var(--space-64);
                }
            }

            .tooltip {
                display: flex;
                justify-content: center;
                align-items: center;
                width: var(--btn-size);
                height: var(--btn-size);
            }
        `;
    }

        render() {
            return html`
                <div @click="${this._scroll}" class="container">
                    <bd-tooltip class="tooltip" tooltip="ასქროლეთ" position="bottom">
                        <bd-icon class="icon" icon="bd:chevron_up"></bd-icon>
                    </bd-tooltip>
                </div>
            `;
        }

        static get properties() {
            return {
                showHeight: {
                    type: Number,
                },
                currentHeight: {
                    type: Number,
                },
                hidden: {
                    type: Boolean,
                    reflect: true,
                },
            };
        }

        constructor() {
            super();
            this.showHeight = 1500;
            this.currentHeight = 0;
            this.hidden = true;
        }

        connectedCallback() {
            super.connectedCallback();
            this._scrollListener = this._scrollListener.bind(this)
            window.addEventListener('scroll', this._scrollListener);
        }

        disconnectedCallback() {
            super.disconnectedCallback();
            window.addEventListener('scroll', this._scrollListener);
        }

        _scrollListener() {
            const shouldHide = window.scrollY <= this.showHeight || window.scrollY <= this.currentHeight;
            if (this.hidden !== shouldHide) this.hidden = shouldHide;

            this.currentHeight = window.scrollY;
        }

    _scroll() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
}

window.customElements.define(SoloScrollUp.is, SoloScrollUp);
